import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    card: 'space-y-1',
    date: 'text-xs',
    description: 'line-clamp-2 text-sm <lg:hidden',
    image: 'mb-3',
    title: 'line-clamp-2 text-sm c-brand-2 fw-medium'
  },
  showDate: true
} satisfies VfConfig['articleCard']
